import { useContext, useEffect, useState } from "react";
import { StyleContext } from "../../providers/StyleContextProvider";
import { ApplicationPopUpLoader } from "../Loaders/ApplicationPopUpLoader";
import useErrorPage from "../../hooks/useErrorPage";
import { fetchApplicantDetails } from "../../services/RecruiterService";
import { Candidate } from "../../models/Candidate";
import { FeedbackCard } from "../Shared/FeedbackCard";

interface Props {
    candidateId: number;
    recruiterId: number;
    token: string;
}

export const InformationTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("applicationStatusTabs");  
    const styles = tabStyles.informationTab;
    const [showFullSummary, setShowFullSummary] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [applicantDetails, setApplicantDetails] = useState<Candidate>();
    const [toErrorPage] = useErrorPage();

    useEffect(() => {
        getApplicantDetails();
    }, []);

    const handleShowFullSummary = () => {
        setShowFullSummary(!showFullSummary);
    };

    const formatNoteText = (text: string) => {
        return text.replace(/\n/g, '<br />');
    };

    async function getApplicantDetails () {
        await fetchApplicantDetails(props.candidateId, props.recruiterId, props.token)
        .then((response) => {
            setApplicantDetails(response);
            setLoading(false);
        })
        .catch((error) => {            
            toErrorPage(error);
        });
    }

    return (
        <>
            <p style={styles.title}>Information</p>
            {loading ? <ApplicationPopUpLoader/> :
                <>  
                    {applicantDetails ? (
                        <>  
                            {applicantDetails?.personalSummary && <div style={styles.personalSummary}>
                                <div style={styles.personalSummary.title}>{"Personal Summary"}</div>       
                                <div style={styles.personalSummary.text}>
                                    {showFullSummary
                                        ? <div dangerouslySetInnerHTML={{ __html: formatNoteText(applicantDetails?.personalSummary!)}}/>
                                        : <div dangerouslySetInnerHTML={{ __html: formatNoteText(`${applicantDetails?.personalSummary.substring(0, 180)}...`)}}/>
                                    }   
                                    {applicantDetails?.personalSummary.length > 180 && (
                                        <span onClick={() => handleShowFullSummary()} style={styles.seeMore}>
                                            {showFullSummary ? "See Less" : "See More"}
                                        </span>
                                    )}  
                                </div>
                            </div>}
                            <div style={styles.details}>
                                {applicantDetails?.email && <div style={styles.details.box}>
                                    <div style={styles.details.title}>{"Email Address"}</div>
                                    <div style={styles.details.text}>{applicantDetails?.email}</div>
                                </div>}
                                {applicantDetails?.mobileNumber && <div style={styles.details.box}>
                                    <div style={styles.details.title}>{"Phone"}</div>
                                    <div style={styles.details.text}>{applicantDetails?.mobileNumber}</div>
                                </div>}
                                {applicantDetails?.address1 && <div style={styles.details.box}>
                                    <div style={styles.details.title}>{"Address"}</div>
                                    <div style={styles.details.text}>{applicantDetails?.address1}</div>
                                </div>}
                                {applicantDetails?.linkedInUrl && <div style={styles.details.box}>
                                    <div style={styles.details.title}>{"LinkedIn Url"}</div>
                                    <div style={styles.details.text}>{applicantDetails?.linkedInUrl}</div>
                                </div>}
                                {applicantDetails?.createdDate && <div style={styles.details.box}>
                                    <div style={styles.details.title}>{"Date Created"}</div>
                                    <div style={styles.details.text}>{applicantDetails?.createdDate && (new Date(applicantDetails.createdDate).toLocaleDateString('en-CA'))}</div>
                                </div>}
                                {applicantDetails?.lastUpdatedDate && <div style={styles.details.box}>
                                    <div style={styles.details.title}>{"Last Modified"}</div>
                                    <div style={styles.details.text}>{new Date(applicantDetails?.lastUpdatedDate!).toLocaleDateString('en-CA')}</div>
                                </div>}
                                {(applicantDetails?.preferredSectors && applicantDetails.preferredSectors!.length > 0) && <div style={styles.details.box}>
                                    <div style={{...styles.details.title, ...styles.details.title.preferredSectors}}>{"Preferred Sectors"}</div>
                                    <div style={styles.details.text}>
                                        {applicantDetails.preferredSectors!.map((sector, index) => (
                                            <div key={index} style={styles.details.sector}>{sector}</div>
                                        ))}
                                    </div>
                                </div>}
                                {applicantDetails?.additionalQualifications && (
                                    <>
                                        <div style={styles.details.qualifications}>{"Additional Qualifications"}</div>
                                            <div style={styles.details.box}>
                                            <div style={styles.details.text}>{applicantDetails?.additionalQualifications}</div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    )   :   (
                        <FeedbackCard
                            styles={styles.noApplicants}
                            message="Candidate hasn't logged in to complete their profile."
                        />
                    )}
                </>
            }
        </>
    );
}